export default __webpack_public_path__ + "static/media/link-circle-fill.0caa721e.svg";